import React from 'react';
import { Helmet } from 'react-helmet';

import { isBuildTime } from '@powdr/utils';

// eslint-disable-next-line import/no-dynamic-require
const { gatsbyConfig } = require(`@powdr/${process.env.GATSBY_PROPERTY_NAME}`);

export const OliveTravel = () => {
  if (isBuildTime() || !gatsbyConfig || !gatsbyConfig?.oliveTravelPropertyId) return null;

  return (
    <Helmet>
      <script
        id="olive-travel"
        src={`https://prod.olive.travel/static/bootstrap/bundle.js?propertyId=${gatsbyConfig?.oliveTravelPropertyId}`}
      />
    </Helmet>
  );
};

OliveTravel.propTypes = {};
